import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import BookingForm from '../BookingForm';
import './ServicePages.css';
import SEO from '../SEO';

const NursingCare = () => {
  const [showBookingForm, setShowBookingForm] = useState(false);

  const handleBookNow = () => {
    setShowBookingForm(true);
  };

  const handleCloseBooking = () => {
    setShowBookingForm(false);
    // Fix button color after form closes
    const buttons = document.querySelectorAll('.book-now-hero-btn, .cta-button, .sidebar-book-btn');
    buttons.forEach(button => {
      button.style.backgroundColor = 'var(--primary-color)';
      button.style.border = 'none';
      button.style.color = 'var(--white-color)';
    });
  };

  const benefits = [
    'Personalized care in familiar surroundings',
    'One-on-one attention from dedicated nurses',
    'Reduced risk of hospital-acquired infections',
    'Greater comfort and convenience',
    'Family involvement in care planning',
    'Cost-effective alternative to hospital stays'
  ];

  const services = [
    {
      name: 'Short-Term Nursing',
      description: 'Post-surgery care, wound management, and recovery support for temporary health needs.'
    },
    {
      name: 'Long-Term Nursing',
      description: 'Ongoing care for chronic conditions, disabilities, or age-related health issues.'
    },
    {
      name: 'Specialized Nursing',
      description: 'Expert care for specific conditions like diabetes, stroke recovery, or cardiac care.'
    },
    {
      name: 'Palliative Nursing',
      description: 'Compassionate care focused on comfort and quality of life for serious illnesses.'
    }
  ];

  return (
    <div className="service-page nursing-page">
      <SEO 
        title="Home Nursing Care Services in Bangalore"
        description="Professional home nursing services in Bangalore. Our registered nurses provide post-surgery care, wound dressing, injection services, and elderly care at home."
        keywords="home nursing services Bangalore, nurse at home Bangalore, patient care services, wound dressing at home, injection at home, elderly nursing care"
      />
      <div className="service-hero">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} md={12}>
              <div className="service-hero-content">
                <h1>Professional Nursing Care</h1>
                <p>Skilled nursing services delivered in the comfort of your home</p>
                <Button className="book-now-hero-btn" onClick={handleBookNow}>
                  Book Appointment
                </Button>
              </div>
            </Col>
            <Col lg={6} md={12}>
              <div className="service-hero-image">
                <img src="/images/nursing.jpg" alt="Nursing Care Services" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="service-content">
        <Row>
          <Col lg={8} md={12}>
            <div className="service-description">
              <h2>Expert Nursing Care at Home</h2>
              <p>
                Our home nursing services provide professional medical care in the comfort and privacy of your own home. 
                Our team of registered nurses and licensed practical nurses are trained to deliver high-quality care 
                tailored to your specific health needs.
              </p>
              <p>
                Whether you need post-operative care, assistance managing a chronic condition, or support during recovery 
                from an illness or injury, our nursing team works closely with your doctors to ensure continuity of care 
                and the best possible outcomes.
              </p>
              
              <h3>Our Nursing Care Services</h3>
              <Row className="treatment-cards">
                {services.map((service, index) => (
                  <Col md={6} key={index} className="mb-4">
                    <Card className="treatment-card h-100">
                      <Card.Body>
                        <Card.Title>{service.name}</Card.Title>
                        <Card.Text>{service.description}</Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
              
              <h3 className="mt-4">What Our Nurses Provide</h3>
              
            </div>
            <ul className="service-list">
                <li>Medication administration and management</li>
                <li>Wound care and dressing changes</li>
                <li>IV therapy and injections</li>
                <li>Vital signs monitoring</li>
                <li>Catheter and ostomy care</li>
                <li>Diabetic care and blood glucose monitoring</li>
                <li>Patient and family education</li>
                <li>Coordination with doctors and specialists</li>
              </ul>
          </Col>
          
          <Col lg={4} md={12}>
            <div className="service-sidebar">
              <Card className="benefits-card">
                <Card.Header as="h5">Benefits of Home Nursing</Card.Header>
                <Card.Body>
                  <ul className="benefits-list">
                    {benefits.map((benefit, index) => (
                      <li key={index}>{benefit}</li>
                    ))}
                  </ul>
                  <div className="d-grid gap-2 mt-4">
                    <Button variant="primary" onClick={handleBookNow} className="sidebar-book-btn">
                      Request a Nurse
                    </Button>
                  </div>
                </Card.Body>
              </Card>
              
              <Card className="why-choose-card mt-4">
                <Card.Header as="h5">Why Choose Our Nursing Care?</Card.Header>
                <Card.Body>
                  <ul className="why-choose-list">
                    <li>Highly qualified and experienced nurses</li>
                    <li>Comprehensive assessment and care planning</li>
                    <li>Regular communication with family members</li>
                    <li>Flexible scheduling options</li>
                    <li>Coordination with your healthcare team</li>
                  </ul>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col md={12}>
            <div className="cta-section text-center">
              <h3>Need Professional Nursing Care?</h3>
              <p>Our skilled nursing team is ready to provide the care you need in the comfort of your home.</p>
              <Button size="lg" onClick={handleBookNow} className="cta-button">
                Schedule a Nursing Consultation
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
      
      <BookingForm 
        show={showBookingForm} 
        handleClose={handleCloseBooking} 
        defaultService="Nursing Care"
      />
    </div>
  );
};

export default NursingCare;
